program SpediFucs;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  UnitMain in 'units\UnitMain.pas'{*.html},
  UnitLogin in 'units\UnitLogin.pas'{*.html},
  CP.Func.AES in '..\WebServer\CP.Func.AES.pas',
  GlobalWeb in '..\Gemeinsames\GlobalWeb.pas',
  SpediFucsDatenmodul in 'units\SpediFucsDatenmodul.pas',
  Konstanten in '..\Gemeinsames\Konstanten.pas',
  GetStammdaten in 'units\GetStammdaten.pas'{*.html},
  AbfKontrolle in 'units\AbfKontrolle.pas'{*.html},
  FsKontrolleEdit in 'units\FsKontrolleEdit.pas'{*.html},
  MaBst in 'units\MaBst.pas'{*.html},
  MaBstEdit in 'units\MaBstEdit.pas'{*.html},
  Schaeden in 'units\Schaeden.pas'{*.html},
  SchadenEdit in 'units\SchadenEdit.pas'{*.html},
  ShowGrafik in 'units\ShowGrafik.pas'{*.html},
  ShowPdf in 'units\ShowPdf.pas'{*.html},
  ShowPos in 'units\ShowPos.pas'{*.html},
  Tau in 'units\Tau.pas'{*.html},
  TauEdit in 'units\TauEdit.pas'{*.html},
  Tour in 'units\Tour.pas'{*.html},
  TourEdit in 'units\TourEdit.pas'{*.html},
  UrlbAntrag in 'units\UrlbAntrag.pas'{*.html},
  UrlbAntragEdit in 'units\UrlbAntragEdit.pas'{*.html},
  WebBasis in 'units\WebBasis.pas'{*.html},
  WebBasis2 in 'units\WebBasis2.pas'{*.html},
  Zeitbuchung in 'units\Zeitbuchung.pas'{*.html},
  GetBarcode in 'units\GetBarcode.pas'{*.html},
  MaBeleg in 'units\MaBeleg.pas'{*.html},
  MaBelegEdit in 'units\MaBelegEdit.pas'{*.html},
  FsKontrolle in 'units\FsKontrolle.pas'{*.html},
  AbfKontrolleEdit in 'units\AbfKontrolleEdit.pas'{*.html},
  AbfKontrollePkt in 'units\AbfKontrollePkt.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TfrmMainForm, frmMainForm);
//  Application.CreateForm(TfrmAbfKontrollePkt, frmAbfKontrollePkt);
  Application.Run;
end.
